import { Styles } from '@typings/common';

export const tooltipContainer: Styles = {
  width: '100%',
  pointerEvents: 'auto',
  cursor: 'default',
};
